export const siteContent = {
  languages: ["it", "en"],
  brand: {
    name: "Rosa Blu Apartment",
    tagline: {
      it: "Eleganza alpina nel cuore della Val di Sole",
      en: "Alpine elegance in the heart of Val di Sole",
    },
  },
  navigation: {
    it: [
      { id: "chi-siamo", label: "Chi siamo" },
      { id: "suites", label: "Appartamento" },
      { id: "val-di-sole", label: "Val di Sole" },
      { id: "faq", label: "FAQ" },
      { id: "contatti", label: "Contatti" },
    ],
    en: [
      { id: "chi-siamo", label: "About" },
      { id: "suites", label: "Apartment" },
      { id: "val-di-sole", label: "Val di Sole" },
      { id: "faq", label: "FAQ" },
      { id: "contatti", label: "Contact" },
    ],
  },
  hero: {
    it: {
      title: "Un rifugio curato, tra legno, luce e dettagli di stile",
      subtitle:
        "Non un semplice appartamento, ma uno spazio pensato per farti sentire subito a casa, connesso alla natura ma con tutto il comfort moderno.",
      primaryCta: "Richiedi disponibilità",
      secondaryCta: "Scopri l'appartamento",
      note: "Nel cuore di Piano di Commezzadura, a pochi minuti dagli impianti sciistici e dai principali sentieri.",
    },
    en: {
      title: "An elegant retreat between wood, light and gentle details",
      subtitle:
        "More than an apartment: a carefully designed space to make you feel at home, close to nature with all modern comforts.",
      primaryCta: "Request availability",
      secondaryCta: "Explore the apartment",
      note: "In the heart of Piano di Commezzadura, just minutes from ski lifts and main hiking trails.",
    },
  },
  about: {
    it: {
      title: "Chi siamo",
      intro:
        "Rosa Blu Apartment nasce dal desiderio di creare un piccolo rifugio curato, intimo e autentico nel cuore della Val di Sole, dove ogni soggiorno possa trasformarsi in un ricordo bello da portare con sé.",
      body:
        "Non è solo una casa vacanze, ma il risultato di un progetto a cui abbiamo dedicato tempo, energia e tanta attenzione ai dettagli. Insieme a mio marito abbiamo seguito ogni fase, dalla ristrutturazione alla scelta dei materiali, dei colori e degli arredi: legno, tessuti morbidi e luci calde che raccontano il nostro modo di vivere la montagna.",
      body2:
        "Ci piace pensare a Rosa Blu Apartment come a uno spazio che accoglie: chi arriva trova ambienti ordinati, funzionali e facili da vivere, ma anche piccoli dettagli che parlano di noi e del territorio. D'inverno è il punto di partenza perfetto per le giornate sugli sci; d'estate diventa una base tranquilla per escursioni, passeggiate e momenti di relax.",
      highlight:
        "A pochi passi dall'appartamento si trova anche il Bar Rosa Blu, il nostro luogo del cuore: qui puoi fare colazione, fermarti per un aperitivo, fare una piccola spesa nel minimarket e trovare sempre un punto di riferimento durante il tuo soggiorno.",
    },
    en: {
      title: "About us",
      intro:
        "Rosa Blu Apartment was born from the desire to create a small, carefully curated and truly authentic retreat in the heart of Val di Sole, where every stay can turn into a beautiful memory.",
      body:
        "It is not just a holiday home, but the result of a project to which we dedicated time, energy and a lot of attention to detail. Together with my husband we followed every stage, from renovation to the choice of materials, colours and furnishings: wood, soft textiles and warm lights that reflect our way of living the mountains.",
      body2:
        "We like to think of Rosa Blu Apartment as a welcoming space: guests find tidy, functional rooms that are easy to live in, but also small details that speak about us and about the local area. In winter, it is the perfect starting point for ski days; in summer, it becomes a quiet base for hikes, walks and moments of relaxation.",
      highlight:
        "Just a few steps from the apartment you will also find Rosa Blu Bar, our favourite place: here you can have breakfast, stop for an aperitivo, do a quick grocery shop in the minimarket and always find a friendly reference point during your stay.",
    },
  },
  suites: {
    it: {
      title: "L'appartamento",
      subtitle: "Spazi luminosi, materiali naturali, dettagli pensati con cura.",
      perks: [
        "Zona giorno con angolo cottura completamente attrezzato",
        "Camera matrimoniale con tessili morbidi e colori rilassanti",
        "Spazi pensati principalmente per coppie, con la possibilità di valutare soluzioni per ospiti aggiuntivi",
        "Bagno moderno con doccia spaziosa",
        "Spazio dedicato per riporre sci, scarponi e attrezzatura sportiva",
      ],
      amenitiesTitle: "Servizi e comfort",
    },
    en: {
      title: "The apartment",
      subtitle: "Bright spaces, natural materials and curated details.",
      perks: [
        "Living area with fully equipped kitchen corner",
        "Master bedroom with soft textiles and relaxing colours",
        "Spaces mainly designed for couples, with the option to evaluate solutions for additional guests",
        "Modern bathroom with spacious shower",
        "Dedicated space to store skis, boots and sports equipment",
      ],
      amenitiesTitle: "Amenities & comforts",
    },
    amenities: [
      { id: "wifi", icon: "Wifi", it: "Wi-Fi ad alta velocità", en: "High-speed Wi-Fi" },
      { id: "parking", icon: "ParkingCircle", it: "Parcheggio gratuito nelle vicinanze", en: "Free nearby parking" },
      { id: "ski", icon: "Snowflake", it: "Vicino agli impianti di risalita Daolasa", en: "Close to Daolasa ski lifts" },
      { id: "family", icon: "Users", it: "Accogliente per soggiorni di coppia o piccoli nuclei", en: "Cosy for couples or small groups" },
      { id: "coffee", icon: "Coffee", it: "Colazione disponibile al Bar Rosa Blu (nelle vicinanze)", en: "Breakfast available at nearby Bar Rosa Blu" },
      { id: "storage", icon: "Package", it: "Ripostiglio per sci e attrezzatura sportiva", en: "Storage for skis and sports equipment" },
    ],
  },
  bar: {
    it: {
      title: "Bar Rosa Blu",
      subtitle:
        "Un'estensione naturale dell'ospitalità di Rosa Blu Apartment, a pochi passi dall'alloggio.",
      points: [
        "Colazioni e pause rilassanti prima o dopo le attività",
        "Ambiente caldo e familiare, frequentato anche dai locali",
        "Tabaccheria, ricevitoria, infopoint pacchi e minimarket ben fornito",
      ],
    },
    en: {
      title: "Rosa Blu Bar",
      subtitle:
        "A natural extension of Rosa Blu Apartment hospitality, just a short walk from the apartment.",
      points: [
        "Breakfasts and relaxing breaks before or after your activities",
        "Warm, friendly atmosphere loved by locals too",
        "Tobacconist, lottery point, parcel infopoint and well-stocked minimarket",
      ],
    },
    location: {
      address: "Via Pietro Bernardelli 18, 38020 Commezzadura (TN)",
      directionsUrl:
        "https://www.google.com/maps/dir/?api=1&origin=Via+del+Zicol+4+38020+Commezzadura+TN&destination=Via+Pietro+Bernardelli+18+38020+Commezzadura+TN&travelmode=walking",
    },
  },
  valDiSole: {
    it: {
      title: "Val di Sole",
      subtitle:
        "Una valle autentica, tra montagne, boschi, fiumi e borghi caratteristici.",
      experiencesTitle: "Cosa puoi fare qui",
    },
    en: {
      title: "Val di Sole",
      subtitle:
        "An authentic valley of mountains, forests, rivers and charming villages.",
      experiencesTitle: "What you can do here",
    },
    experiences: [
      {
        id: "ski",
        it: {
          title: "Sci e snowboard",
          text: "Daolasa collega direttamente alla Skiarea Campiglio Dolomiti di Brenta con oltre 150 km di piste collegate sci ai piedi.",
        },
        en: {
          title: "Ski & snowboard",
          text: "From Daolasa you reach the Campiglio Dolomiti di Brenta ski area with over 150 km of connected slopes.",
        },
      },
      {
        id: "trekking",
        it: {
          title: "Trekking ed escursioni",
          text: "Sentieri panoramici verso rifugi come Solander e Orso Bruno, con vista sulle Dolomiti di Brenta.",
        },
        en: {
          title: "Hiking & walks",
          text: "Panoramic trails to mountain huts such as Solander and Orso Bruno, with Dolomiti di Brenta views.",
        },
      },
      {
        id: "bike",
        it: {
          title: "Mountain bike e Bike Park",
          text: "Commezzadura ospita il Bike Park Val di Sole, tappa della Coppa del Mondo MTB, con percorsi per esperti e famiglie.",
        },
        en: {
          title: "Mountain bike & Bike Park",
          text: "Commezzadura is home to the Val di Sole Bike Park, a World Cup venue with trails for experts and families.",
        },
      },
      {
        id: "rafting",
        it: {
          title: "Rafting sul Noce",
          text: "Il fiume Noce è tra i migliori al mondo per il rafting, con centri specializzati nei dintorni di Commezzadura.",
        },
        en: {
          title: "Rafting on river Noce",
          text: "The Noce river is one of the best in the world for rafting, with several centres around Commezzadura.",
        },
      },
    ],
  },
  activities: {
    it: {
      title: "Cosa fare a Commezzadura e in Val di Sole",
      intro:
        "Rosa Blu Apartment si trova a pochi minuti dalla partenza della telecabina Daolasa e dal fiume Noce: una posizione ideale per vivere la montagna in tutte le stagioni.",
      sections: {
        winter: {
          title: "Inverno · Neve e sci",
          subtitle:
            "Daolasa è il cuore pulsante dell'attività invernale in Val di Sole.",
          items: [
            "Telecabina Daolasa - Val Mastellina: parte dal fondovalle e porta in quota in circa 12 minuti.",
            "Accesso diretto alla Skiarea Campiglio Dolomiti di Brenta con oltre 150 km di piste collegate con Folgarida, Marilleva e Madonna di Campiglio.",
            "Sci di fondo su anelli dedicati nelle vicinanze, come Vermiglio e Cogolo.",
            "Ciaspolate nei boschi innevati con guide alpine, verso malghe e rifugi.",
            "Après-ski alla partenza della telecabina, tra locali, musica e atmosfera conviviale.",
          ],
        },
        summer: {
          title: "Estate · Sport e natura",
          subtitle:
            "L'estate trasforma la valle in un paradiso outdoor famoso a livello internazionale.",
          items: [
            "Bike Park Val di Sole: percorsi Downhill ed Enduro per esperti e trail più semplici per chi vuole avvicinarsi alla MTB.",
            "Pista ciclabile della Val di Sole lungo il fiume Noce, perfetta anche per famiglie.",
            "Rafting sul fiume Noce, considerato dal National Geographic tra i migliori al mondo per questo sport.",
            "Passeggiate ed escursioni panoramiche dalla stazione a monte di Daolasa verso rifugi come Solander e Orso Bruno.",
            "Escursioni ai laghi alpini nelle valli vicine.",
          ],
        },
        surroundings: {
          title: "Dintorni · Gite fuori porta",
          subtitle:
            "Da Commezzadura puoi raggiungere facilmente alcune delle mete più suggestive della valle.",
          items: [
            "Val di Rabbi con le Terme, il ponte sospeso e le cascate del Saent.",
            "Parco Nazionale dello Stelvio (Val di Pejo) per avvistare cervi, caprioli e respirare natura incontaminata.",
            "Castel Caldes e altri borghi storici per una giornata tra cultura e tradizione.",
          ],
        },
      },
    },
    en: {
      title: "What to do in Commezzadura and Val di Sole",
      intro:
        "Rosa Blu Apartment is just a few minutes from the Daolasa cable car and the Noce river: a perfect location to enjoy the mountains all year round.",
      sections: {
        winter: {
          title: "Winter · Snow and ski",
          subtitle:
            "Daolasa is the beating heart of winter activities in Val di Sole.",
          items: [
            "Daolasa - Val Mastellina cable car: from the valley floor to the slopes in about 12 minutes.",
            "Direct access to the Campiglio Dolomiti di Brenta ski area with over 150 km of connected slopes.",
            "Cross-country ski rings in nearby areas such as Vermiglio and Cogolo.",
            "Snowshoeing in snowy woods with alpine guides, up to huts and mountain lodges.",
            "Après-ski area at the cable car departure, with bars, music and a lively atmosphere.",
          ],
        },
        summer: {
          title: "Summer · Sports and nature",
          subtitle:
            "In summer the valley becomes an outdoor paradise known worldwide.",
          items: [
            "Val di Sole Bike Park: downhill and enduro tracks for experts plus easier trails.",
            "Cycling path along the Noce river, also perfect for families.",
            "Rafting on the Noce river, considered among the best in the world.",
            "Panoramic hikes from the Daolasa upper station towards huts like Solander and Orso Bruno.",
            "Excursions to alpine lakes in the surrounding valleys.",
          ],
        },
        surroundings: {
          title: "Surroundings · Day trips",
          subtitle:
            "From Commezzadura you can easily reach some of the most beautiful spots in the valley.",
          items: [
            "Val di Rabbi with its thermal baths, suspension bridge and Saent waterfalls.",
            "Stelvio National Park (Val di Pejo) to spot deer and enjoy untouched nature.",
            "Castel Caldes and historic villages for a day dedicated to culture and traditions.",
          ],
        },
      },
    },
  },
  location: {
    it: {
      title: "Posizione",
      subtitle:
        "Rosa Blu Apartment si trova in una zona centrale e comodissima per raggiungere le principali mete della valle.",
      highlights: [
        "Madonna di Campiglio",
        "Passo del Tonale",
        "Val di Rabbi",
      ],
    },
    en: {
      title: "Location",
      subtitle:
        "Rosa Blu Apartment is in a central, convenient position to reach the main destinations in the valley.",
      highlights: ["Madonna di Campiglio", "Passo del Tonale", "Val di Rabbi"],
    },
  },
  faq: {
    it: {
      title: "Domande frequenti",
      items: [
        {
          id: "check-in",
          question: "Quali sono gli orari di check-in e check-out?",
          answer:
            "In genere il check-in è nel pomeriggio e il check-out alla mattina; potremo concordare insieme gli orari precisi in base alle tue esigenze e alla disponibilità.",
        },
        {
          id: "bambini",
          question: "La struttura è pensata anche per famiglie?",
          answer:
            "L'appartamento è pensato principalmente per soggiorni di coppia o piccoli nuclei; possiamo valutare insieme eventuali esigenze particolari.",
        },
        {
          id: "animali",
          question: "Sono ammessi animali domestici?",
          answer:
            "Gli animali sono ammessi su richiesta e potrebbe essere previsto un piccolo supplemento: ti invitiamo a segnalarlo al momento della richiesta.",
        },
        {
          id: "parcheggio",
          question: "È disponibile il parcheggio?",
          answer:
            "È disponibile parcheggio privato gratuito nelle vicinanze; ti forniremo tutti i dettagli pratici prima dell'arrivo.",
        },
      ],
    },
    en: {
      title: "Frequently asked questions",
      items: [
        {
          id: "check-in",
          question: "What are check-in and check-out times?",
          answer:
            "Check-in is usually in the afternoon and check-out in the morning; we can agree the exact times together according to your needs and availability.",
        },
        {
          id: "bambini",
          question: "Is the apartment suitable for families?",
          answer:
            "The apartment is mainly designed for couples or small groups; we can discuss special needs together.",
        },
        {
          id: "animali",
          question: "Are pets allowed?",
          answer:
            "Pets are allowed on request and a small supplement may apply: please mention it when you request availability.",
        },
        {
          id: "parcheggio",
          question: "Is parking available?",
          answer:
            "Free private parking is available nearby; we will share all practical details before your arrival.",
        },
      ],
    },
  },
  reviews: {
    it: [
      {
        id: "rec1",
        name: "Marco",
        text:
          "Soggiorno fantastico! L'appartamento era pulitissimo, ben arredato e molto accogliente. La posizione in Val di Sole è perfetta per esplorare la zona sia in estate che in inverno.",
        tag: "Dicembre 2023",
      },
      {
        id: "rec2",
        name: "Sofia",
        text:
          "Ci siamo trovati benissimo! L'appartamento Rosa Blu è un vero gioiello. La camera da letto era spaziosa e confortevole, e il bagno con la doccia idromassaggio era un sogno.",
        tag: "Gennaio 2024",
      },
      {
        id: "rec3",
        name: "Elena",
        text:
          "Appartamento perfetto! Pulizia impeccabile, design curato e tutto perfettamente funzionante. La posizione è ideale per chi ama la natura e le attività all'aria aperta.",
        tag: "Marzo 2024",
      },
      {
        id: "rec4",
        name: "Andrea",
        text:
          "Soggiorno eccellente. L'appartamento è esattamente come descritto, anzi, forse anche meglio. Curato nei minimi dettagli, pulito e dotato di tutto il necessario.",
        tag: "Aprile 2024",
      },
      {
        id: "rec5",
        name: "Martina",
        text:
          "Esperienza fantastica! L'appartamento è spazioso, luminoso e dotato di ogni comfort. La pulizia è stata impeccabile e la posizione ottima per le nostre escursioni.",
        tag: "Luglio 2024",
      },
      {
        id: "rec6",
        name: "Laura",
        text:
          "Davvero un soggiorno perfetto! L'appartamento è spazioso, pulito e dotato di tutto il necessario. La posizione è fantastica per chi ama la montagna.",
        tag: "Novembre 2024",
      },
    ],
    en: [
      {
        id: "rec1",
        name: "Marco",
        text:
          "Fantastic stay! The apartment was spotless, well furnished and very welcoming. The location in Val di Sole is perfect for exploring the area in both summer and winter.",
        tag: "December 2023",
      },
      {
        id: "rec2",
        name: "Sofia",
        text:
          "We had a wonderful time! Rosa Blu Apartment is a real gem. The bedroom was spacious and comfortable, and the bathroom with the hydromassage shower was a dream.",
        tag: "January 2024",
      },
      {
        id: "rec3",
        name: "Elena",
        text:
          "Perfect apartment! Impeccable cleanliness, careful design and everything perfectly working. The location is ideal for nature lovers and outdoor activities.",
        tag: "March 2024",
      },
      {
        id: "rec4",
        name: "Andrea",
        text:
          "Excellent stay. The apartment is exactly as described, in fact, perhaps even better. Attention to every detail, clean and equipped with everything you need.",
        tag: "April 2024",
      },
      {
        id: "rec5",
        name: "Martina",
        text:
          "Fantastic experience! The apartment is spacious, bright and equipped with every comfort. The cleanliness was impeccable and the location excellent for our excursions.",
        tag: "July 2024",
      },
      {
        id: "rec6",
        name: "Laura",
        text:
          "Really a perfect stay! The apartment is spacious, clean and equipped with everything necessary. The location is fantastic for mountain lovers.",
        tag: "November 2024",
      },
    ],
  },
  contact: {
    it: {
      title: "Contatti",
      subtitle:
        "Scrivici per richiedere disponibilità, informazioni o per creare un soggiorno su misura.",
      form: {
        name: "Nome e cognome",
        email: "Email",
        message: "Messaggio",
        dates: "Date indicative del soggiorno",
        guests: "Numero di ospiti",
        submit: "Invia richiesta",
        success:
          "Richiesta inviata (mock). In seguito collegheremo questo form alla casella email ufficiale.",
      },
    },
    en: {
      title: "Contact",
      subtitle:
        "Write to us to request availability, information or to design a tailor-made stay.",
      form: {
        name: "Full name",
        email: "Email",
        message: "Message",
        dates: "Preferred dates",
        guests: "Number of guests",
        submit: "Send request",
        success:
          "Request sent (mock). Later we will connect this form to the official email inbox.",
      },
    },
  },
  contactInfo: {
    address: "Via del Zicol, 4 - 38020 Piano di Commezzadura (TN)",
    phone: "389 515 1393",
    email: "tullia.bezzi@yahoo.it",
    socials: {
      instagram: "@rosabluapartment",
      facebook: "@rosabluapartment",
    },
  },
};
